// extracted by mini-css-extract-plugin
export default {"chart":"StatProspect_chart__98ywP","legend":"StatProspect_legend__XP8ZU","title":"StatProspect_title__vtO6e","percent":"StatProspect_percent__Oz20z"};